export const SettlementClientRoleType = {
    CHANNEL_CLIENT: 0,
    DSP_CLIENT: 1,
} as const;

export type SettlementClientRoleTypeValue =
    typeof SettlementClientRoleType[keyof typeof SettlementClientRoleType];

export const settlementClientRoleTypeOptions = [
    { label: '客户(channel)', value: SettlementClientRoleType.CHANNEL_CLIENT },
    { label: 'DSP', value: SettlementClientRoleType.DSP_CLIENT },
];
